import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../web/styles/styles';

const interItemSpacing = 15;

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		overflow: 'hidden',
	},
	item: {
		height: 200,
		width: 300,
	},
	itemIcon: {
		height: '100%',
		objectFit: 'contain',
		width: '100%',
	},
	items: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: interItemSpacing,
	},
	googleBusinessItem: {
		...CssSelectors.allChildren({
			marginBottom: 6,
		}),
	},
	statusMessage: {
		fontSize: 12,
	},
	metaAdsIcon: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'svg'
		),
	},
	metaAdsLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.standard,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
});
